export default "__VITE_ASSET__CTbELO36__"